import { DialogContent as MuiDialogContent } from "@mui/material";
import React from "react";
export const DialogContent = (props) => {
    return (React.createElement(MuiDialogContent, { ...props, className: props.className, style: props.style, sx: ({ palette }) => ({ "&.MuiDialogContent-root": { backgroundColor: palette.controls.dialog.contentBackground, padding: "30px 30px 12px" } }) }));
};
